import moment from 'moment'
import React, { useState } from 'react'

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import { productIcon } from '../helpers'
import InputAdornment from '@material-ui/core/InputAdornment'

import { Page, Toolbar } from 'react-onsenui'

import { TextField } from '@material-ui/core'

import ForecastProductPicker from '../components/ForecastProductPicker'
import ForecastFarmPicker from '../components/ForecastFarmPicker'

export const forecastMappedData = forecastData => {
  const { hundreds, tens, units, thousands } = forecastData

  let mapped = ''
  // mapped = mapped + thousands.value + hundreds.value + tens.value + units.value
  if (thousands.value > 0) mapped += thousands.value

  if (hundreds.value === 0 && thousands.value > 0) mapped += hundreds.value
  if (hundreds.value > 0) mapped += hundreds.value

  if (tens.value === 0 && (hundreds.value > 0 || thousands.value > 0)) mapped += tens.value
  if (tens.value > 0) mapped += tens.value

  if ((hundreds.value > 0 || thousands.value > 0 || tens.value > 0) && units.value === 0) mapped += units.value
  if (units.value > 0) mapped += units.value

  // if ((hundreds.value > 0 || tens.value > 0) && units.value === 0) mapped += units.value
  return mapped
}

const ForecastCreateScreen = props => {
  const [noProduct, setProductNotif] = useState(false)
  const [noFarm, setFarmNotif] = useState(false)
  const [noQuantity, setQuantityNotif] = useState(false)
  const {
    forecastDate,
    changeForecastDate,
    forecastProductData,
    forecastFarmData,
    forecastId,
    forecastFarmsOptions,
  } = props

  let dateLabel = moment(forecastDate, 'DD-MM-YYYY').format('dddd')
  if (moment(forecastDate, 'DD-MM-YYYY').isSame(moment().add(1, 'days'), 'day')) {
    dateLabel = 'mañana'
  } else if (moment(forecastDate, 'DD-MM-YYYY').isSame(moment(), 'day')) {
    dateLabel = 'hoy'
  }

  moment(forecastDate, 'DD-MM-YYYY')

  const getFarm = () => {
    if (forecastFarmsOptions && forecastFarmsOptions.length === 1) {
      return forecastFarmsOptions[0].label
    } else if (forecastFarmData && forecastFarmData.farms) {
      return forecastFarmData.farms.label
    } else return 'Elegir un agricultor'
  }

  const onSubmit = () => {
    if (!props.forecastQuantityData) setQuantityNotif(true)
    if (!props.forecastProductData) setProductNotif(true)
    if (props.forecastQuantityData && props.forecastProductData) {
      props.sendForecastData()
    }
  }

  return (
    <React.Fragment>
      <Page
        renderToolbar={() => (
          <Toolbar className={props.classes.appBar}>
            <div className="left">
              <KeyboardArrowLeftIcon
                onClick={() => {
                  props.resetForecastData()
                  props.goBack()
                }}
                className={props.classes.goBackIcon}
              />
            </div>
            <div className="center">
              <Typography className={props.classes.title}>Crear previsión</Typography>
            </div>
          </Toolbar>
        )}>
        <Grid item container>
          <Grid item xs={12}>
            <div className={props.classes.main}>
              <Grid container spacing={16} alignItems="center">
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  {forecastProductData && forecastProductData.products ? (
                    <img
                      src={productIcon(forecastProductData.products.productIconFileName)}
                      className={props.classes.productIcon}
                    />
                  ) : (
                    <p className={props.classes.productText}>Sin elegir</p>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <div className={props.classes.heading}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                      <Button
                        style={{ width: '95%', fontSize: '1rem', marginBottom: 10, alignSelf: 'center' }}
                        variant="raised"
                        onClick={() => {
                          setProductNotif(false)
                          props.openForecastProductPicker()
                        }}>
                        {forecastProductData && forecastProductData.products
                          ? forecastProductData.products.label
                          : 'Elegir un producto'}
                      </Button>
                      {noProduct && (
                        <span style={{ textAlign: 'center', color: 'red' }}>¡Hace falta elegir un producto!</span>
                      )}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <Button
                      style={{ width: '95%', fontSize: '1rem', marginBottom: 10, alignSelf: 'center' }}
                      variant="raised"
                      onClick={() => {
                        setFarmNotif(false)
                        if (forecastFarmsOptions && forecastFarmsOptions.length > 1) {
                          props.openForecastFarmPicker()
                        }
                      }}>
                      {getFarm()}
                    </Button>
                    {noFarm && <span style={{ textAlign: 'center', color: 'red' }}>¡Hace falta elegir un agricultor!</span>}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={props.classes.entry}>
              <div style={{ width: 300, margin: 'auto', display: 'flex', flexDirection: 'row' }}>
                <Button
                  disabled={moment().isSame(moment(forecastDate, 'DD-MM-YYYY'), 'day')}
                  style={{ alignSelf: 'center', marginRight: 20, fontSize: 25 }}
                  variant="contained"
                  onClick={() => {
                    const today = moment()
                    const actual = moment(forecastDate, 'DD-MM-YYYY')
                    if (today.isSame(actual, 'day')) {
                      console.log('CANT REST TOMORROW')
                    } else {
                      actual.subtract(1, 'day')
                      if (actual.day() === 0) {
                        if (today.isSame(actual, 'day')) {
                          console.log('CANT REST TOMORROW')
                          actual.add(1, 'day')
                        } else {
                          actual.subtract(1, 'day')
                        }
                      }
                      changeForecastDate(actual.format('DD-MM-YYYY').toLocaleString())
                    }
                  }}>
                  -
                </Button>
                <div>
                  <Typography component="p" className={props.classes.dateTitleEntry}>
                    Para la fecha
                  </Typography>
                  <Typography className={props.classes.dateEntry}>{ dateLabel }</Typography>
                </div>
                <Button
                  style={{ alignSelf: 'center', marginLeft: 20, fontSize: 25 }}
                  variant="contained"
                  disabled={moment()
                    .startOf('day')
                    .add(6, 'day')
                    .isSame(moment(forecastDate, 'DD-MM-YYYY'))}
                  onClick={() => {
                    const today = moment()
                      .add(1, 'day')
                      .startOf('day')
                    if (today.add(5, 'day').isSame(moment(forecastDate, 'DD-MM-YYYY'))) return
                    const addingDate = moment(forecastDate, 'DD-MM-YYYY')
                      .add(1, 'day')
                    if (addingDate.day() === 0) {
                      addingDate.add(1, 'day')
                    }
                    changeForecastDate(addingDate.format('DD-MM-YYYY').toLocaleString())
                  }}>
                  +
                </Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={props.classes.main}>
              <Grid className={props.classes.chosingEntries} container alignItems="center">
                <Grid item xs={12} alignItems="center">
                  <div className={props.classes.heading}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
                      {noQuantity && (
                        <span style={{ textAlign: 'center', color: 'red' }}>¡Hace falta elegir una cantidad!</span>
                      )}
                      <TextField
                        type="tel"
                        name="txtNumber"
                        style={{ width: 260, fontSize: 24, marginTop: 15, alignSelf: 'center' }}
                        classes={{
                          input: props.classes.inputRight,
                        }}
                        inputProps={{
                          style: {
                            fontSize: 30,
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              <span style={{ color: '#000000' }}>Kg</span>
                            </InputAdornment>
                          ),
                        }}
                        value={props.forecastQuantityData}
                        onKeyPress={(ev) => {
                          if (ev.key === 'Enter') {
                            onSubmit()
                            ev.preventDefault();
                          }
                        }}
                        onChange={e => {
                          setQuantityNotif(false)
                          const { value } = e.target
                          if (/^\d+$/.test(value) || value === '') {
                            props.setForecastQuantityData(value)
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: '-6px' }} />
                </Grid>
              </Grid>
              <Grid className={props.classes.chosingEntries} container alignItems="center">
                <Grid item xs={12} alignItems="center">
                  <div className={props.classes.heading}>
                    <Button
                      style={{ width: 260, fontSize: 20, marginTop: 25 }}
                      variant="raised"
                      onClick={onSubmit}>
                      {`${forecastId ? 'Guardar' : 'Crear'} previsión`}
                    </Button>
                  </div>
                  <div style={{ marginTop: '-6px' }} />
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <div style={{ height: 200 }}></div>
      </Page>
      <ForecastProductPicker {...props} />
      <ForecastFarmPicker {...props} />
    </React.Fragment>
  )
}

const styles = {
  inputRight: {
    textAlign: 'right',
  },
  appBar: {
    background: '#1B458E',
  },
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  heading: {
    display: 'flex',
    justifyContent: 'center',
  },
  main: {
    padding: 5,
  },
  entry: {
    background: '#1B458E',
    padding: 5,
  },
  dateTitleEntry: {
    color: 'white',
    textAlign: 'center',
    fontSize: 14,
  },
  dateEntry: {
    color: 'white',
    textAlign: 'center',
    fontSize: 25,
  },
  productIcon: {
    // width: '100%',
    height: 150,
  },
  productText: {
    height: 150,
    width: 150,
    fontSize: 17,
    margin: 'auto',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  chosingEntries: {
    marginTop: 10,
  },
  chosingEntryTitle: {
    marginTop: 10,
    fontSize: 20,
    textAlign: 'right',
  },
}

export default withStyles(styles)(ForecastCreateScreen)



// WEBPACK FOOTER //
// ./src/screens/ForecastCreateScreen.js